import React from "react";
import C1 from "../../assets/clients/Logo-01.jpg";
import C2 from "../../assets/clients/Logo-02.jpg";
import C3 from "../../assets/clients/Logo-03.jpg";
import C4 from "../../assets/clients/Logo-04.jpg";
import C5 from "../../assets/clients/Logo-05.jpg";
import C6 from "../../assets/clients/Logo-06.jpg";
import C7 from "../../assets/clients/logo-07.jpg";
import C8 from "../../assets/clients/logo-08.jpg";
import C9 from "../../assets/clients/logo-09.jpg";
import C10 from "../../assets/clients/logo-10.jpg";
import C11 from "../../assets/clients/logo-11.jpg";
import C12 from "../../assets/clients/logo-12.jpg";
import C13 from "../../assets/clients/logo-13.jpg";
import C14 from "../../assets/clients/logo-14.jpg";
import C15 from "../../assets/clients/logo-15.jpg";
import C16 from "../../assets/clients/logo-16.jpg";
import C17 from "../../assets/clients/logo-17.jpg";
import C18 from "../../assets/clients/logo-18.jpg";
import C19 from "../../assets/clients/logo-19.jpg";

const cards = [
  { images: C1, alt: "Client 1" },
  { images: C2, alt: "Client 2" },
  { images: C3, alt: "Client 3" },
  { images: C4, alt: "Client 4" },
  { images: C5, alt: "Client 5" },
  { images: C6, alt: "Client 6" },
  { images: C7, alt: "Client 7" },
  { images: C8, alt: "Client 8" },
  { images: C9, alt: "Client 9" },
  { images: C10, alt: "Client 10" },
  { images: C11, alt: "Client 11" },
  { images: C12, alt: "Client 12" },
  { images: C13, alt: "Client 13" },
  { images: C14, alt: "Client 14" },
  { images: C15, alt: "Client 15" },
  { images: C16, alt: "Client 16" },
  { images: C17, alt: "Client 17" },
  { images: C18, alt: "Client 18" },
  { images: C19, alt: "Client 19" },
];

const OurClients = () => {
  // Duplicate array for smooth loop
  const logos = [...cards, ...cards];

  return (
    <section className="py-16 bg--500 px-3 bg-primaryPri overflow-hidden">
      <div className="c px-4">
        <div className="flex flex-col md:flex-row gap-1">
          {/* Left Section */}
          <div className="md:w-1/3">
            <h2 className="md:text-3xl text-2xl font-semibold text-gray-800 border-l-4 border-main1 pl-2">
              Our Clients
            </h2>
            <p className="text-gray-700 text-sm mt-4 leading-relaxed">
              <strong>At Deetya Soft</strong>, we prioritize your business goals
              by delivering tailored, innovative solutions with a focus on
              quality and efficiency. Our client-centric approach ensures
              reliable support and long-term success.
            </p>
          </div>

          {/* Right Section - Scrolling 2x1 layout */}
          <div className="md:w-2/3 overflow-hidden">
            <div className="flex animate-carousel gap-6 w-max">
              {logos.map((_, i) => {
                // Only every even index to avoid duplicate rendering
                if (i % 2 !== 0) return null;

                return (
                  <div
                    key={i}
                    className="flex flex-col gap-6"
                    style={{ minWidth: "200px", maxWidth: "200px" }}
                  >
                    {/* Top Logo */}
                    <div className="flex justify-center items-center border rounded-md shadow-sm bg-white p-3 h-[80px]">
                      <img
                        src={logos[i].images}
                        alt={logos[i].alt}
                        className="object-contain h-full max-w-[100px]"
                      />
                    </div>

                    {/* Bottom Logo */}
                    {logos[i + 1] && (
                      <div className="flex justify-center items-center border rounded-md shadow-sm bg-white p-3 h-[80px]">
                        <img
                          src={logos[i + 1].images}
                          alt={logos[i + 1].alt}
                          className="object-contain h-full max-w-[100px]"
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Inline style for animation */}
      <style jsx>{`
        .animate-carousel {
          animation: scrollLeft 25s linear infinite;
        }

        @keyframes scrollLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
};

export default OurClients;
